import MirsTable from "components/general/table/Table";
import Competitors from "components/presentation/Competitor"

import { findArray } from 'helpers/utils'
import Label from "components/general/Label"

const DivProgressionRule = ({ config }) => {
    let rule = findArray(config.extendedConfig, { code: ['QUAL_RULE'], type: ['QUALIFICATION'] })?.value

    let valProgression = (rule !== undefined)
        ? <> <b><Label data="LabelProgressionRule" />:</b> {rule} </>
        : ''

    return (
        <>
            <div>
                {valProgression}
            </div>
        </>
    )

};
export default DivProgressionRule;